import { ComponentType, lazy } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { AppConfig } from 'shared/types/app'

export enum PublicAppId {
  CLUSTER_TRANSFER = 'cluster-transfer',
  CLUSTER_FILES = AppId.CLUSTER_FILES,
  SUPPORT_CENTER = 'support-center',
  TASKS = 'tasks'
}

type PublicAppConfig = Pick<AppConfig, 'path' | 'routeProps'> & {
  id: PublicAppId
  component: ComponentType
  options: {
    /**
     * If true, then user will be redirected to main app if authenticated.
     * i.e., `/public` will be removed.
     */
    isHybrid?: true
    /**
     * If true, then language code is added to route path. i.e., `/public/en`
     */
    isLocalizedRoute?: boolean
  }
}

const ClusterTransferApp = lazy(() =>
  import('modules/app-registry/components/PublicApps/ClusterTransferApp').then(
    m => ({
      default: m.ClusterTransferApp
    })
  )
)

const ClusterFilesApp = lazy(() =>
  import('modules/app-registry/components/ClusterFilesApp').then(m => ({
    default: m.ClusterFilesApp
  }))
)

const TaskManagementApp = lazy(() =>
  import('modules/app-registry/components/TaskManagementApp').then(m => ({
    default: m.TaskManagementApp
  }))
)

export const publicAppConfigs: Record<PublicAppId, PublicAppConfig> = {
  [PublicAppId.CLUSTER_TRANSFER]: {
    id: PublicAppId.CLUSTER_TRANSFER,
    component: ClusterTransferApp,
    path: '/transfer',
    routeProps: { exact: true },
    options: {
      isLocalizedRoute: true
    }
  },
  [PublicAppId.CLUSTER_FILES]: {
    id: PublicAppId.CLUSTER_FILES,
    component: ClusterFilesApp,
    path: '/cluster-files',
    options: {
      isHybrid: true
    },
    routeProps: {}
  },
  [PublicAppId.SUPPORT_CENTER]: {
    id: PublicAppId.SUPPORT_CENTER,
    component: TaskManagementApp,
    path: '/support-center',
    options: {},
    routeProps: {}
  },
  [PublicAppId.TASKS]: {
    id: PublicAppId.TASKS,
    component: TaskManagementApp,
    path: '/tasks',
    options: {},
    routeProps: {}
  }
}
